module.exports = __webpack_public_path__ + "static/media/loader.ce7f767d.svg";